<template>
    <div>
        <div class="p-4 pb-0" v-if="isNewExamination">
            <h5>Yeni Muayene</h5>
            <hr>
            <div class="row">
                <div class="col-lg-6">
                    <label for="examination-date" class="fw-semibold">Muayene Tarihi: </label>
                    <input type="text" v-model="newExaminationData.examination_date" class="form-control"
                        placeholder="Muayene Tarihi">
                </div>
                <div class="col-lg-6">
                    <label for="findings" class="fw-semibold">Bulgular: </label>
                    <input type="text" class="form-control" placeholder="Bulgular"
                        v-model="newExaminationData.findings">
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-lg-3">
                    <label for="examination-date" class="fw-semibold">Ağırlık: </label>
                    <input type="text" v-model="newExaminationData.weight" class="form-control" placeholder="Ağırlık">
                </div>
                <div class="col-lg-3">
                    <label for="findings" class="fw-semibold">Vücut Isısı: </label>
                    <input type="text" class="form-control" placeholder="Vücut Isısı"
                        v-model="newExaminationData.temperature">
                </div>
                <div class="col-lg-3">
                    <label for="findings" class="fw-semibold">Kalp Ritmi: </label>
                    <input type="text" class="form-control" placeholder="Kalp Ritmi"
                        v-model="newExaminationData.heart_rate">
                </div>
                <div class=" col-lg-3">
                    <label for="dehydration" class="fw-semibold">Dehidrasyon: </label>
                    <select class="form-select" data-select2-selector="icon" v-model="newExaminationData.dehydration"
                        @change="newExaminationData.dehydration = $event.target.value">
                        <option value=true data-icon="feather-check text-success">Evet</option>
                        <option value=false data-icon="feather-x text-danger" selected>Hayır</option>
                    </select>
                </div>
                <div class="row">
                    <div class="col-lg-12 d-flex justify-content-end mt-4">
                        <button @click="isNewExamination = false"
                            class="me-2 btn btn-lg btn-light-brand">Vazgeç</button>
                        <button @click="postExamination()" class="btn btn-lg btn-success">Kaydet</button>
                    </div>
                </div>
            </div>
            <hr>
        </div>
        <div class="recent-activity p-4 pb-0">
            <div class="mb-4 pb-2 d-flex justify-content-between">
                <h5 class="fw-bold">Yapılan Muayeneler:</h5>
                <button @click="isNewExamination = true" v-if="!isNewExamination"
                    class="btn btn-sm btn-light-brand">Yeni
                    Muayene</button>
            </div>
            <ul class="list-unstyled activity-feed">
                <li v-for="examination in examinations"
                    class="d-flex justify-content-between feed-item feed-item-success">
                    <div>
                        <span class="text">{{ formatDate(examination.examination_date) }}<br>
                            <a class="fw-bold text-primary">{{ examination.findings }}</a>
                        </span>
                        <span class="text-truncate-1-line lead_date">
                            Ağırlık: {{ examination.weight }},
                            Vücut Sıcaklığı: {{ examination.temperature }},
                            Kalp Ritmi: {{ examination.heart_rate }},
                            Dehidrasyon: {{ examination.dehydration }}
                        </span>
                    </div>
                    <div class="ms-3 d-flex gap-2 align-items-center">
                        <button @click="deleteExamination(examination.id)" class="avatar-text avatar-sm bg-danger">
                            <i class="feather feather-trash-2 fs-12"></i>
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
export default {
    name: 'AnimalExaminations',
    data() {
        return {
            examinations: [],
            isNewExamination: false,
            newExaminationData: {
                examination_date: '',
                findings: '',
                weight: '',
                temperature: '',
                heart_rate: '',
                dehydration: false,
            },
        }
    },
    props: {
        animalId: {
            type: Number,
            required: true,
        },
    },
    mounted() {

    },
    methods: {
        async fetchAnimalExaminations() {
            console.log('AnmalId: ', this.animalId);
            try {
                const response = await this.$axios.get(`examination/?animal=${this.animalId}`);
                this.examinations = await response.data.results;
                console.log('examinations:', this.examinations);
            } catch (error) {
                console.error(error);
            }
        },
        async postExamination() {
            this.newExaminationData.animal = this.animalId;
            try {
                const payload = {
                    ...this.newExaminationData,
                    examination_date: dayjs(this.newExaminationData.examination_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                };
                this.newExaminationData = payload;
                const response = await this.$axios.post('examination/', this.newExaminationData);
                this.examinations.unshift(response.data);
                this.newExaminationData = {
                    examination_date: '',
                    findings: '',
                    weight: '',
                    temperature: '',
                    heart_rate: '',
                    dehydration: false,
                };
                this.isNewExamination = false;
            } catch (error) {
                console.error(error);
            }
        },
        async deleteExamination(examinationId) {
            try {
                await this.$axios.delete(`examination/${examinationId}/`);
                this.examinations = this.examinations.filter(
                    (examination) => examination.id !== examinationId
                );
            } catch (error) {
                console.error(error);
            }
        },
        formatDate(date) {
            if (!date) {
                return '';
            }
            return dayjs(date).format('DD.MM.YYYY');
        },

    }
}
</script>